import { render, staticRenderFns } from "./Edit_profile.vue?vue&type=template&id=6eca25d1&scoped=true&"
import script from "./Edit_profile.vue?vue&type=script&lang=js&"
export * from "./Edit_profile.vue?vue&type=script&lang=js&"
import style0 from "./Edit_profile.vue?vue&type=style&index=0&id=6eca25d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca25d1",
  null
  
)

export default component.exports